module.exports = __webpack_public_path__ + "img/banner.d80c90ad.jpg";